import { useState } from "react";

import { PageLayout, PageTitle } from "components/layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMeQuery } from "@/services/user";
import { isUserAdminInGroup } from "@/utils/user";
import { layoutClasses } from "@/utils/css-classes";

import DepositStoresPanel from "./list/panel";
import DepositBatchesPanel from "./admin/batches/panel";

export default function DepositReconciliationIndex() {
  const { data: currentUser } = useMeQuery();
  const moduleAccess = localStorage.getItem("@verzel:module");
  const isAdmin = isUserAdminInGroup(currentUser, moduleAccess ?? "");

  const [tab, setTab] = useState<"stores" | "batches">("stores");

  if (!isAdmin) {
    return (
      <PageLayout>
        <div className={layoutClasses.pageContainer}>
          <PageTitle
            title="Conciliação de Depósitos"
            description="Lista de Lojas"
            titleSize="text-3xl"
            descriptionSize="text-xl"
          />
          <DepositStoresPanel />
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className={layoutClasses.pageContainer}>
        <PageTitle
          title="Conciliação de Depósitos"
          description="Lista de lojas e conciliações concluídas"
          titleSize="text-3xl"
          descriptionSize="text-xl"
        />
        <Tabs
          value={tab}
          onValueChange={v => setTab(v as "stores" | "batches")}
          className="w-full mt-6"
        >
          <TabsList className="grid w-full max-w-md grid-cols-2 rounded-lg bg-white border p-1">
            <TabsTrigger
              className="rounded-md transition-all data-[state=active]:bg-[#2E0D1E] data-[state=active]:text-white data-[state=active]:shadow-sm"
              value="stores"
            >
              Lista de Lojas
            </TabsTrigger>
            <TabsTrigger
              className="rounded-md transition-all data-[state=active]:bg-[#2E0D1E] data-[state=active]:text-white data-[state=active]:shadow-sm"
              value="batches"
            >
              Conciliações Concluídas
            </TabsTrigger>
          </TabsList>
          <TabsContent value="stores">
            <DepositStoresPanel />
          </TabsContent>
          <TabsContent value="batches">
            <DepositBatchesPanel />
          </TabsContent>
        </Tabs>
      </div>
    </PageLayout>
  );
}
